import type { NestedKeys } from '../../types.ts';

/**
 * `en` · `errors` namespace — user-facing error copy. Codes map roughly to the
 * `AppError` families surfaced at the edge (quota → 402, auth → 401).
 */
export const errors = {
  generic: 'Something went wrong. Please try again.',
  network: 'Connection lost. Check your network and retry.',
  quota: {
    exceeded: 'You have reached your limit. Upgrade to keep going.',
    credits: 'Not enough credits for {action}.',
  },
  auth: {
    unauthorized: 'Please sign in to continue.',
    ageRequired: 'You must be 18 or older to use 4fantasia.',
  },
  media: {
    failed: 'Generation failed: {reason}.',
    blocked: 'That request was blocked by our safety filters.',
  },
} as const;

export type ErrorsMessages = typeof errors;

/** Typo-safe dot-path keys for the `errors` namespace. */
export type ErrorsKey = NestedKeys<ErrorsMessages>;
